import { Box, Typography, Fab, darken } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from '@mui/styles';
import clsx from "clsx";

// common

const BannerSection = () => {

  return (
    <Box component="section" className="section" id="intro" sx={{ pb: 0 }}>
      <Box sx={{ background: { sm: "url(./assets/banner/strgy_dev.jpg) center center/cover no-repeat", xs: '#0060fb' }, opacity: '0.5' }}>
        <Box sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 1rem",
          maxWidth: "1170px",
          margin: "0 auto",
          minHeight: '360px'
        }}>
          <Box sx={{
            width: '450px',
            pt: 6
          }}>
            <Typography component="div" sx={{ fontSize: '40px', color: '#ffffff', mb: 2 }}>Develop & Implement</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '18px', color: '#ffffff', mb: 2 }}>1, 多因子時系列アルゴリズムの開発、</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '18px', color: '#ffffff', mb: 2 }}>2, 金融取引戦略の実装、</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '18px', color: '#ffffff' }}>3, および自動取引システムの構築。</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { BannerSection };
